import React, { useEffect, useLayoutEffect, useState } from "react";
import { Navigate, Route, Router, Routes } from "react-router-dom";
import Login from "./features/Login/Login";
import PublicBadge from "./features/PublicBadge/PublicBadge";
import { history } from "./services/history";
import PageNotFound from "./features/PageNotFound/PageNotFound";
import Badges from "./features/Badges/Badges";
import { useDispatch, useSelector } from "react-redux";
import { getSessionRead } from "./store/session/sessionSelectors";
import { readSession } from "./store/session/sessionActions";
import { I18nextProvider } from "react-i18next";
import i18n from "./translations/i18n";

export const routesConfig = [
  { path: "/", element: <Navigate replace to="/login" /> },
  { path: "/login", element: <Login /> },
  { path: "/badges/:id", element: <PublicBadge /> },
  { path: "/page-not-found", element: <PageNotFound /> },
  { path: "*", element: <Navigate replace to="/page-not-found" /> },
  { path: "*", element: <Navigate to="/" /> },
  { path: "/badges", element: <Badges /> },
];

const App: React.FC<any> = () => {
  const dispatch = useDispatch();

  const storedRoute = sessionStorage?.getItem("ga__route");
  const notReadSession = storedRoute?.includes("/badges/");
  const dataloaded = useSelector(getSessionRead);

  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  useEffect(() => {
    if (!dataloaded && location && !notReadSession) {
      dispatch(readSession());
    }
  }, [dataloaded]);

  return (
    <Router
      location={state.location}
      navigator={history}
      navigationType={state.action}>
      <I18nextProvider i18n={i18n}>
        <Routes>
          {routesConfig?.map((route, index) => (
            <Route path={route?.path} element={route?.element} />
          ))}
        </Routes>
      </I18nextProvider>
    </Router>
  );
};

export default App;
